import { Box, Paper } from '@mui/material';
import { FC, useEffect, useMemo } from 'react';
import { GoPlus } from "react-icons/go";
import { CubageVariantProductFormDrawer } from '../../../Components/Drawer/variants/cubage-product-form/cubage-variant-product-form-drawer.component';
import { Button } from '../../../Components/Form/Button/button.scomponent';
import { CubageTable } from '../../../Components/Table/variants/cubage-table/cubage-table.component';
import { BaseContentPage } from '../../../Components/Templates/BaseContentPage/base-content-page.componen';
import { BaseScreen } from '../../../Components/Templates/BaseScreen/basescreen.component';
import { ListProductUseCase } from '../../../Usecase/Products/list-product-usecase';
import { useCubages } from './cubage-list.hook';
import { CreateCubagesUseCase } from '../../../Usecase/Cubages/create-cubages-usecase';
import { ListCubagesUseCase } from '../../../Usecase/Cubages/list-cubages-usecase';
import { CreateCubagesVariationsUseCase } from '../../../Usecase/CubagesVariations/create-cubages-variations-usecase';
import { ListBoxesUseCase } from '../../../Usecase/Boxes/list-boxes-usecase';
import { ShowCubagesVariationsUseCase } from '../../../Usecase/CubagesVariations/show-cubages-variations-usecase';
import { UpdateubagesVariationsUseCase } from '../../../Usecase/CubagesVariations/update-cubages-variations-usecase';
import { DestroyCubagesVariationsUseCase } from '../../../Usecase/CubagesVariations/destroy-cubages-variations-usecase';
import { ShowCubagesUseCase } from '../../../Usecase/Cubages/show-cubages-usecase';
import { UpdateCubagesUseCase } from '../../../Usecase/Cubages/update-cubages-usecase';
import { DestroyCubagesUseCase } from '../../../Usecase/Cubages/destroy-cubages-usecase';
import { ConfirmDialog } from '../../../Components/Dialog/variants/dialog-confirmation/dialog-confirmation.component';
import { Can } from '../../../Components/Can';
import { Placeholder } from '../../../Components/Placeholder/placeholder.component';
import { TableListSkeleton } from '../../../Components/Table/table-list-skeleton.component';

interface ICubageList {
    listProductUseCase: ListProductUseCase
    createCubagesUseCase: CreateCubagesUseCase
    listCubagesUseCase: ListCubagesUseCase
    createCubagesVariationsUseCase: CreateCubagesVariationsUseCase
    listBoxesUseCase: ListBoxesUseCase
    showCubagesVariationsUseCase: ShowCubagesVariationsUseCase
    updateubagesVariationsUseCase: UpdateubagesVariationsUseCase
    destroyCubagesVariationsUseCase: DestroyCubagesVariationsUseCase
    showCubagesUseCase: ShowCubagesUseCase
    updateCubagesUseCase: UpdateCubagesUseCase
    destroyCubagesUseCase: DestroyCubagesUseCase
}

const CubageList : FC<ICubageList> = ({
    listProductUseCase,
    createCubagesUseCase,
    listCubagesUseCase,
    createCubagesVariationsUseCase,
    listBoxesUseCase,
    showCubagesVariationsUseCase,
    updateubagesVariationsUseCase,
    destroyCubagesVariationsUseCase,
    showCubagesUseCase,
    updateCubagesUseCase,
    destroyCubagesUseCase,
}) => {
    const {
      listCubages,
      list,
      data,
      showNewCubage,
      setShowNewCubage,
      loading,
      loadError,
      handleCreateCubage,
      handleCreateCubageVariation,
      cubageProductIdSelected,
      boxOptions,
      setCubageProductIdSelected,
      setCubageVariantSelected,
      cubageVariantSelected,
      handleUpdateCubageVariation,
      cubageVariantToDestroy,
      setCubageVariantToDestroy,
      handleDestroyVariant,
      variantProductSelected,
      setVariantProductSelected,
      variantProductToDestroy,
      setVariantProductToDestroy,
      handleShowCubage,
      handleUpdateCubage,
      handleDestroyCubage,
      loadInitialData,
    } = useCubages({
        listProductUseCase,
        createCubagesUseCase,
        listCubagesUseCase,
        createCubagesVariationsUseCase,
        listBoxesUseCase,
        showCubagesVariationsUseCase,
        updateubagesVariationsUseCase,
        destroyCubagesVariationsUseCase,
        showCubagesUseCase,
        updateCubagesUseCase,
        destroyCubagesUseCase,
    })

    useEffect(() => {
        loadInitialData()
    }, [loadInitialData])

    const variantProductToDestroyName = useMemo(() => {
      if (!variantProductToDestroy) return 'este produto'
      return data.find((item) => item.id === variantProductToDestroy)?.name || 'este produto'
    }, [variantProductToDestroy, data])

    return (
        <Can permissions={['menu:cubages:manage']}>
        <BaseScreen>
        <ConfirmDialog
          title="Remover produto de cubagem"
          onCancel={() => setVariantProductToDestroy('')}
          description={`Tem certeza que deseja remover "${variantProductToDestroyName}"?`}
          open={!!variantProductToDestroy}
          onConfirm={() => handleDestroyCubage(String(variantProductToDestroy))}
        />

        {(showNewCubage || !!variantProductSelected?.id) && (
          <CubageVariantProductFormDrawer
            open={showNewCubage || !!variantProductSelected?.id}
            loading={loading}
            onToggle={() => {
              if (variantProductSelected?.id) {
                setVariantProductSelected(undefined);
              } else {
                setShowNewCubage((prev) => !prev);
              }
            }}
            title={variantProductSelected ? 'Editar produto de cubagem' : 'Novo produto de cubagem'}
            handleAction={variantProductSelected ? handleUpdateCubage : handleCreateCubage}
            variantProductSelected={variantProductSelected}
          />
        )}

            <Paper sx={{ borderRadius: 2, overflow: 'hidden', width: '100%' }}>
                <BaseContentPage
                    title="Tabela de Cubagem"
                    subtitle="Gerencie produtos e suas variações de cubagem por caixa"
                    breadcrumb={[
                      { title: 'Tabela de Cubagem', link: "/cubage-list" },
                      { title: 'Listagem' },
                    ]}
                    minHeight="auto"
                    Action={() => (
                      <Button
                        LeftIcon={() => <GoPlus size={18} />}
                        sx={{ width: { xs: '100%', sm: 'auto' }, minWidth: { sm: 170 }, flexShrink: 0 }}
                        boxLeftSx={{ gap: '10px', marginLeft: '5px' }}
                        textSx={{ textTransform: 'Capitalize', fontWeight: 500, whiteSpace: 'nowrap' }}
                        onClick={() => setShowNewCubage(true)}
                      >
                        Adicionar produto
                      </Button>
                    )}
                >
                  <Box sx={{ width: '100%', minWidth: 0 }}>
                    {loading && !list.length ? (
                      <TableListSkeleton rows={6} rowHeight={64} />
                    ) : loadError ? (
                      <Placeholder
                        description="Não foi possível carregar a tabela de cubagem."
                        onRetry={loadInitialData}
                      />
                    ) : !list.length ? (
                      <Placeholder description="Nenhum produto de cubagem encontrado." />
                    ) : (
                      <CubageTable
                        data={list}
                        handleAction={cubageVariantSelected?.id ? handleUpdateCubageVariation : handleCreateCubageVariation}
                        cubageProductIdSelected={cubageProductIdSelected}
                        boxOptions={boxOptions ?? []}
                        setCubageProductIdSelected={setCubageProductIdSelected}
                        setCubageVariantSelected={setCubageVariantSelected}
                        cubageVariantSelected={cubageVariantSelected}
                        cubageVariantToDestroy={cubageVariantToDestroy}
                        setCubageVariantToDestroy={setCubageVariantToDestroy}
                        handleDestroyVariant={handleDestroyVariant}
                        handleShowCubage={handleShowCubage}
                        setVariantProductToDestroy={setVariantProductToDestroy}
                      />
                    )}
                  </Box>
                </BaseContentPage>
            </Paper>
        </BaseScreen>
        </Can>
    )
}

export { CubageList };
